import { useMutation } from '@connectrpc/connect-query'
import { createBiddingBlockApprovalRequest } from '@ebalance/proto/bffuser/v1/bidding_block_service-BiddingBlockService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { blockApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'
import { invalidateFeePreviewsOnRejection } from '~/pages/SpotBidding/hooks/spotFeePreviewInvalidation'
import { isBlockFeePreviewStale } from '~/pages/SpotBidding/models/blockBidWrite'

/**
 * ブロック入札 承認依頼 新規作成 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。 手数料の理由で拒否された時は
 * 開いたままのモーダルが突き合わせているプレビューと設定を取り直す (AC-BSP-004b)。
 */
export function useCreateBiddingBlockApprovalRequest(): InvalidatingMutationResultFor<
  typeof createBiddingBlockApprovalRequest
> {
  const queryClient = useQueryClient()
  return useWorkflowCaseScopedMutation(
    useMutation(createBiddingBlockApprovalRequest, {
      onSuccess: () =>
        Promise.all(
          blockApprovalRequestInvalidationKeys.map((queryKey) =>
            queryClient.invalidateQueries({ queryKey }),
          ),
        ),
      onError: (err) =>
        invalidateFeePreviewsOnRejection(
          queryClient,
          err,
          isBlockFeePreviewStale,
        ),
    }),
  )
}
